import { Link } from "react-router-dom";

const navigationPhotos = [
  {
    id: "przygotowania.jpg",
    width: 2000,
    height: 1331,
    path: "/przygotowania",
    name: "Przygotowania",
  },
  {
    id: "slub.jpg",
    width: 2000,
    height: 1331,
    path: "/slub",
    name: "Ślub",
  },
  {
    id: "wesele.jpg",
    width: 2000,
    height: 1331,
    path: "/wesele",
    name: "Wesele",
  },
];

const Navigation = () => {
  return (
    <>
      <div className="text-center py-5">
        <h1 className="mb-4">Dziękujemy, że byliście z nami!</h1>
      </div>

      <div className="xxx">
        <div className="row">
          {navigationPhotos.map((e, i) => (
            <div className="col-12 col-sm-4" key={i}>
              <div className="p-2">
                <Link to={e.path} className="nameLink">
                  <h3 style={{ textDecoration: "none" }}>{e.name}</h3>
                  <img
                    src={`/photos/navigation/${e.id}`}
                    className="img-fluid"
                    alt=""
                  />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Navigation;
